<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 48">
    <g fill="none" fill-rule="evenodd">
        <g>
            <g transform="translate(-797 -1231) translate(797 1231)">
                <rect class="fill" width="80" height="40" x="4" y="4" fill="#000" rx="20"/>
                <circle cx="24" cy="24" r="12" fill="#FFF"/>
                <path fill="#FFF" d="M64 4c11.046 0 20 8.954 20 20s-8.954 20-20 20H24C12.954 44 4 35.046 4 24S12.954 4 24 4h40zm0 2H24C14.059 6 6 14.059 6 24c0 9.764 7.774 17.712 17.47 17.992L24 42h40c9.941 0 18-8.059 18-18 0-9.764-7.774-17.712-17.47-17.992L64 6z"/>
                <path class="fill" fill="#000" d="M64 0H24C10.745 0 0 10.745 0 24s10.745 24 24 24h40c13.255 0 24-10.745 24-24S77.255 0 64 0zm0 4c11.046 0 20 8.954 20 20s-8.954 20-20 20H24C12.954 44 4 35.046 4 24S12.954 4 24 4h40z"/>
            </g>
        </g>
    </g>
</svg>
